import { render, staticRenderFns } from "./MultiClipartSelector.vue?vue&type=template&id=a3bf9f04"
import script from "./MultiClipartSelector.vue?vue&type=script&lang=js"
export * from "./MultiClipartSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports